import SlickSlider from '../../../../../elements/SlickSlider'
import styles from './styles.module.scss'
import IconSlider from '/public/icons/icon-slider.svg'
import { withModifiers } from '../../../../../helpers/withModifiers'
import { getS3Url } from '../../../../../helpers/getS3Url'
import isEmpty from 'lodash-es/isEmpty'
import { useRouter } from 'next/router'

const Modal = ({ property, translations }) => {
  const router = useRouter()
  const videos =
    !isEmpty(property.video) && property.video.map((item) => getS3Url(item))

  return (
    <div>
      <span className={styles.city}>{property.city || property.county}</span>
      <h1>{property.propertyTitle || property.title}</h1>

      <SlickSlider
        className={styles.slider}
        slidesToShow={1}
        synced
        videos={videos}
        cloudflare={property.cloudflare_additional_video}
        infinite={false}
        nextArrow={
          <div className={styles.slider__arrow}>
            {translations?.next[router.locale]} <IconSlider />
          </div>
        }
        prevArrow={
          <div className={withModifiers('slider__arrow', ['left'], styles)}>
            {translations?.previous[router.locale]} <IconSlider />
          </div>
        }
      >
        {property.cloudflare_gallery && !isEmpty(property.cloudflare_gallery)
          ? property?.cloudflare_gallery.map((item, index) => (
              <span key={index}>
                <div className={styles.slider__gallery}>
                  <img
                    index={index}
                    sizes="(min-width: 1250px) 1250px, (max-width: 1250px) 50vw, 1250px"
                    src={getS3Url(item)}
                  />
                </div>
              </span>
            ))
          : property?.pictures &&
            property?.pictures.map((item, index) => (
              <span key={index}>
                <div className={styles.slider__gallery}>
                  <img
                    index={index}
                    sizes="(min-width: 1250px) 1250px, (max-width: 1250px) 50vw, 1250px"
                    src={item.original}
                  />
                  hello
                </div>
              </span>
            ))}
      </SlickSlider>
    </div>
  )
}

export default Modal
